// Execute the script after the DOM is fully loaded
        document.addEventListener("DOMContentLoaded", function() {
            // Check if the screen width is 600 pixels or less
            if (window.innerWidth <= 600) {
                // Select the elements and set their display property to "block"
                var elementsToShow = document.querySelectorAll('.announce2, .needhelp, .trustpilotblock, .dkvirksomhed');
                
                elementsToShow.forEach(function(element) {
                    element.style.display = 'block';
                });
            }
        });



 document.addEventListener('DOMContentLoaded', function () {
      var announcementBar = document.querySelector('.announce2');
      var announcementTexts = document.querySelectorAll('.needhelp, .announcement-bar-text1, .trustpilotblock, .dkvirksomhed');
      var currentIndex = 0;
      var intervalTime = 5000; // Adjust the time between announcements in milliseconds

      function showNextAnnouncement() {
        announcementTexts.forEach(function (text) {
          text.style.display = 'none';
        });

        currentIndex = (currentIndex + 1) % announcementTexts.length;

        if (window.innerWidth < 600) {
          announcementTexts[currentIndex].style.display = 'flex';
        }
      }

      function showMobileAnnouncement() {
        if (announcementTexts.length > 0 && window.innerWidth < 600) {
          announcementTexts.forEach(function (text) {
            text.style.display = 'none';
          });

          announcementTexts[0].style.display = 'flex'; // Display the first announcement on load
        }
      }

      function handleWindowResize() {
        if (window.innerWidth < 600) {
          showMobileAnnouncement();
        } else {
          announcementTexts.forEach(function (text) {
            text.style.display = ''; // Reset the display property to its default
          });
        }
      }

      if (announcementBar && window.innerWidth < 600) {
        showMobileAnnouncement(); // Call this function to show the mobile announcement on load
        setInterval(showNextAnnouncement, intervalTime);

        // Add event listener for window resize
        window.addEventListener('resize', handleWindowResize);
      }
    });


document.addEventListener("DOMContentLoaded", function () {
    const quickBuyDrawers = document.querySelectorAll("quick-buy-drawer");

    quickBuyDrawers.forEach((quickBuyDrawer) => {
        quickBuyDrawer.addEventListener("click", function (event) {
            const buyButton = event.target.closest("button[type='submit']");

            if (buyButton) {
                setTimeout(() => {
                    quickBuyDrawer.setAttribute("hidden", "");
                    quickBuyDrawer.style.display = "none";
                }, 500);
            }
        });
    });
});
 